// ModalPortal.jsx
import { createPortal } from "react-dom";

export default function ModalPortal({ children }) {
  // If you have a #modal-root you can target that; otherwise body is fine.
  return createPortal(children, document.body);
}
